import React from 'react';
import TableComponent from '../../components/TableComponent';
import Routes from '../../constants/routes';
import { MotivesService } from '../../service';
import Utils from '../../Utils';
const tableHead = [
  {
    id: 'name',
    label: 'Nome',
  },
];
class MotivesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
    };
    this.getPage();
  }

  async getPage() {
    try {
      const res = await MotivesService.list('motives');
      this.setState({ data: res.data, loading: false });
    } catch (e) {
      console.log(e);
    }
  }

  onCreateClick = () => {
    this.props.history.push(Routes.newMotives);
  };

  onEditClick = id => {
    this.props.history.push(Routes.editMotives.replace(':id', id));
  };

  onDeleteClick = item => {
    Utils.alertRemove(MotivesService, this.state.data, item).then(data => {
      this.setState({ data });
    });
  };

  render() {
    return (
      <TableComponent
        loading={this.state.loading}
        tableTitle="Motivos"
        tableHead={tableHead}
        addText="Novo"
        data={this.state.data}
        onCreateClick={this.onCreateClick}
        onEditClick={this.onEditClick}
        onDeleteClick={this.onDeleteClick}
      />
    );
  }
}

export { MotivesList };
